import { render, staticRenderFns } from "./NavTileComponent.vue?vue&type=template&id=4fdbbfeb&scoped=true&"
import script from "./NavTileComponent.vue?vue&type=script&lang=js&"
export * from "./NavTileComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavTileComponent.vue?vue&type=style&index=0&id=4fdbbfeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbbfeb",
  null
  
)

export default component.exports